<template>
  <a-sub-menu :key="item.fullPath">
    <template #icon v-if="item.meta.icon && item.meta.icon !== ''">
      <ehf-icon :icon="item.meta.icon"></ehf-icon>
    </template>
    <template #title>
      <span>{{ item.meta.title }}</span>
    </template>
    <slot></slot>
  </a-sub-menu>
</template>

<script>
  export default {
    name: 'Submenu',
    components: {},
    props: {
      item: {
        type: Object,
        default() {
          return null
        },
      },
      routeChildren: {
        type: Object,
        default() {
          return null
        },
      },
    },
    methods: {},
  }
</script>
